var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "filters-popover" }, [
    _c("div", { staticClass: "filter-pl-section" }, [
      _c(
        "label",
        {
          staticClass: "filter-pl-title mb-2",
          attrs: { for: _vm.configSelectId },
        },
        [_vm._v("Dashboard config")]
      ),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.dashboardConfigModel,
              expression: "dashboardConfigModel",
            },
          ],
          staticClass: "form-control",
          attrs: { id: _vm.configSelectId, disabled: _vm.loading },
          on: {
            change: function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.dashboardConfigModel = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
          },
        },
        [
          _c("option", { attrs: { value: "" } }, [
            _vm._v("\n        Based on Product Lists\n      "),
          ]),
          _vm._v(" "),
          _c("option", { attrs: { value: "all" } }, [
            _vm._v("\n        All configurations\n      "),
          ]),
          _vm._v(" "),
          _vm._l(_vm.configs, function (config) {
            return _c(
              "option",
              { key: config.id, domProps: { value: String(config.id) } },
              [_vm._v("\n        " + _vm._s(config.display_name) + "\n      ")]
            )
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "filter-pl-section" }, [
      _c("div", { staticClass: "filter-pl-header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("span", { staticClass: "filter-pl-actions" }, [
          _c(
            "button",
            {
              staticClass: "filter-pl-action-btn",
              attrs: { type: "button", disabled: _vm.loading },
              on: {
                click: function ($event) {
                  return _vm.$emit("select-all")
                },
              },
            },
            [_vm._v("All")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "filter-pl-action-btn filter-pl-action-btn--danger",
              attrs: { type: "button", disabled: _vm.loading },
              on: {
                click: function ($event) {
                  return _vm.$emit("clear-all")
                },
              },
            },
            [_vm._v("Clear")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.productListsLoaded && _vm.productLists.length > 0
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.listSearch,
                expression: "listSearch",
              },
            ],
            staticClass: "filter-pl-search",
            attrs: { type: "text", placeholder: "Search product lists…" },
            domProps: { value: _vm.listSearch },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.listSearch = $event.target.value
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "filter-pl-list",
          class: { "filter-pl-list--loading": _vm.loading },
        },
        [
          _c(
            "label",
            {
              staticClass: "filter-pl-item",
              attrs: {
                title:
                  "Shows reports that are not attached to any product list. Turn it off and select the Dashboard list to see only items explicitly added to Dashboard.",
              },
            },
            [
              _c("input", {
                attrs: { type: "checkbox" },
                domProps: { checked: _vm.individualItems },
                on: {
                  change: function ($event) {
                    return _vm.$emit(
                      "update:individualItems",
                      $event.target.checked
                    )
                  },
                },
              }),
              _vm._v(" "),
              _vm._m(1),
            ]
          ),
          _vm._v(" "),
          _vm.productListsLoadError
            ? _c("p", { staticClass: "filter-pl-status" }, [
                _vm._v("\n        Could not load product lists.\n      "),
              ])
            : !_vm.productListsLoaded
            ? _c("p", { staticClass: "filter-pl-status" }, [
                _vm._v("\n        Loading…\n      "),
              ])
            : _vm.productLists.length > 0
            ? [
                _vm._l(_vm.visibleProductLists, function (list) {
                  return _c(
                    "label",
                    { key: list.id, staticClass: "filter-pl-item" },
                    [
                      _c("input", {
                        attrs: { type: "checkbox", disabled: _vm.loading },
                        domProps: {
                          checked: _vm.selectedLists.includes(list.id),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("toggle-list", list.id)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(list.name) +
                            "\n            "
                        ),
                        _vm.isDashboardList(list)
                          ? _c("span", { staticClass: "filter-pl-hint" }, [
                              _vm._v("(selected reports)"),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.visibleProductLists.length === 0
                  ? _c("p", { staticClass: "filter-pl-status" }, [
                      _vm._v(
                        "\n          No product lists match your search.\n        "
                      ),
                    ])
                  : _vm._e(),
              ]
            : _c("p", { staticClass: "filter-pl-status" }, [
                _vm._v("\n        No product lists yet.\n      "),
              ]),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "filter-pl-new-link",
          attrs: { href: "/product-id-list/form" },
        },
        [_vm._v("+ New product list")]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "filter-menu-item" }, [
      _c("i", { staticClass: "bi bi-shop filter-menu-icon" }),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.retailerModel,
              expression: "retailerModel",
            },
          ],
          staticClass: "form-control filter-menu-select",
          on: {
            change: function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.retailerModel = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
          },
        },
        _vm._l(_vm.retailerOptions, function (option) {
          return _c(
            "option",
            { key: option.value, domProps: { value: option.value } },
            [_vm._v("\n        " + _vm._s(option.label) + "\n      ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("i", { staticClass: "bi bi-chevron-down filter-menu-chevron" }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "filter-menu-item" }, [
      _c("i", { staticClass: "bi bi-tags filter-menu-icon" }),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.categoryModel,
              expression: "categoryModel",
            },
          ],
          staticClass: "form-control filter-menu-select",
          on: {
            change: function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.categoryModel = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
          },
        },
        _vm._l(_vm.categoryOptions, function (option) {
          return _c(
            "option",
            { key: option.value, domProps: { value: option.value } },
            [_vm._v("\n        " + _vm._s(option.label) + "\n      ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("i", { staticClass: "bi bi-chevron-down filter-menu-chevron" }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "filter-menu-item" }, [
      _c("i", { staticClass: "bi bi-box-seam filter-menu-icon" }),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.brandModel,
              expression: "brandModel",
            },
          ],
          staticClass: "form-control filter-menu-select",
          on: {
            change: function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.brandModel = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
          },
        },
        _vm._l(_vm.brandOptions, function (option) {
          return _c(
            "option",
            { key: option.value, domProps: { value: option.value } },
            [_vm._v("\n        " + _vm._s(option.label) + "\n      ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("i", { staticClass: "bi bi-chevron-down filter-menu-chevron" }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "filter-pl-title" }, [
      _c("i", { staticClass: "bi bi-collection" }),
      _vm._v("\n        Product Lists\n      "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _vm._v("\n          Individual items\n          "),
      _c("span", { staticClass: "filter-pl-hint" }, [_vm._v("(not in lists)")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }